class FindYourFitForm extends HTMLElement {
  constructor() {
    super();
    this.baseCollectionUrl = this.dataset.collectionBaseUrl;
    this.form = this.querySelector('form');
    this.bandSizeInput = this.form.querySelector('[name="bandSize"]');
    this.bustSizeInput = this.form.querySelector('[name="bustSize"]');
    this.resultContainer = this.form.querySelector('[data-result-container]');
    this.resultElement = this.querySelector('[data-result]');
    this.collectionLinkElement = this.querySelector('[data-collection-link]');

    this.form.addEventListener('submit', this.onFormSubmit.bind(this));
  }

  onFormSubmit(event) {
    event.preventDefault();
    event.stopPropagation();
    this.resetForm();
    const bustSizeError = this.validateBustSize();
    if (bustSizeError.hasError) {
      const errorDiv = document.createElement("div");
      errorDiv.classList.add('FindYourFitForm--inputError');
      errorDiv.setAttribute('data-error', 'data-error');
      errorDiv.innerHTML = bustSizeError.message;
      this.bustSizeInput.insertAdjacentElement("afterend", errorDiv);
      return;
    }
    
    this.calculateResultSize();
  }

  resetForm() {
    this.resultContainer.setAttribute('hidden', 'hidden');
    this.resultElement.innerHTML = '';
    this.collectionLinkElement.setAttribute('hidden', 'hidden');
    this.collectionLinkElement.setAttribute('href', '#');
    if (this.querySelector('[data-error]')) {
      this.querySelectorAll('[data-error]').forEach((error) => error.remove());
    } 
  }

  validateBustSize() {
    const bustSize = parseInt(this.bustSizeInput.value);
    const bandSize = parseInt(this.bandSizeInput.value);
    const isBandSizeEven = bandSize % 2 == 0;
    const additionalCoefficient = isBandSizeEven ? 0 : 1;
    let hasError = false;
    let message = '';

    if (bandSize > 37) {
      if (bustSize < (bandSize + additionalCoefficient) || bustSize > (bandSize + additionalCoefficient + 10)) {
        hasError = true;
        message = `Please enter a number between ${bandSize + additionalCoefficient} and ${bandSize + additionalCoefficient + 10} inches`;
      }
    } else {
      if (bustSize < (bandSize + additionalCoefficient + 2) || bustSize > (bandSize + additionalCoefficient + 12)) {
        hasError = true;
        message = `Please enter a number between ${bandSize + additionalCoefficient + 2} and ${bandSize + additionalCoefficient + 12} inches`;
      }
    }
    
    return {
      hasError,
      message,
    }
  }

  calculateResultSize() {
    const bustSize = parseInt(this.bustSizeInput.value);
    const bandSize = parseInt(this.bandSizeInput.value);
    const isBandSizeEven = bandSize % 2 == 0;

    let bandSizeResult = bandSize;
    if (bandSize < 38) {
      bandSizeResult += isBandSizeEven ? 2 : 3;
    } else {
      bandSizeResult += isBandSizeEven ? 0 : 1;
    }

    const bustSizeResult = bustSize - bandSizeResult;
    
    const bustSizeResultLetters = ["A","B","C","D","E","F","G","H","I","J","K","L"];
    const bustSizeResultLetter = bustSizeResultLetters[bustSizeResult] ? bustSizeResultLetters[bustSizeResult] : '';


    this.resultContainer.removeAttribute('hidden');
    this.resultElement.innerHTML = `${bandSizeResult} ${bustSizeResultLetter}`;

    this.collectionLinkElement.removeAttribute('hidden');
    this.collectionLinkElement.setAttribute('href', `${this.baseCollectionUrl}?filter.v.option.band+size=${encodeURIComponent(bandSizeResult)}&filter.v.option.cup+size=${encodeURIComponent(bustSizeResultLetter)}`);
    this.collectionLinkElement.scrollIntoView({ behavior: "smooth", block: "end"});
  }
}

customElements.define('find-your-fit-form', FindYourFitForm);